import { useSelector } from "react-redux";

import { routes } from "constants/routes";
import { useIntegrations } from "hooks/useIntegrations";
import { useUserFeature } from "hooks/useUserFeature";
import { ISideBarType } from "models/Base";
import { selectAccount } from "store/auth/selector";

export const HAULPAY_ITEMS = (): ISideBarType[] => {
  const {
    isBrokerSubscribed,
    isRequestPayRole,
    isBulkUploadRole,
    isCarrierSubscribed,
    isHistoryRole,
    isAssignedLoadsRole,
    isFactoringRole,
    isBroker,
    isConnectionsRole,
    isWalletEnabled,
    canAccessReceivables
  } = useUserFeature();

  const items: (ISideBarType | undefined)[] = [
    {
      link: routes.HAULPAY_BROKER_MANAGE_PAY,
      title: "Manage Pay",
      hidden: !isBrokerSubscribed
    },
    {
      link: routes.HAULPAY_CARRIER_REQUEST_PAY,
      title: "Request Pay",
      hidden: !isRequestPayRole
    },
    {
      link: routes.HAULPAY_CARRIER_MANAGE_PAY,
      title: "Manage Pay",
      hidden: !isHistoryRole
    },
    {
      link: isBrokerSubscribed
        ? routes.HAULPAY_BROKER_BULK_UPLOADS
        : routes.HAULPAY_CARRIER_BULK_UPLOADS,
      title: "Bulk Upload",
      hidden: !isBulkUploadRole
    },
    {
      link: routes.HAULPAY_BROKER_RECEIVABLES,
      title: "Receivables",
      hidden: !canAccessReceivables
    },
    {
      link: routes.HAULPAY_CARRIER_PAYMENT_PREFERENCE,
      title: "Connections",
      hidden: !isConnectionsRole
    },
    {
      link: routes.HAULPAY_ASSIGNED_LOADS,
      title: "Assigned",
      hidden: !isAssignedLoadsRole
    },
    {
      link: routes.HAULPAY_BROKER_CARRIERS_ORIGIN,
      title: "My Carriers",
      hidden: !isBrokerSubscribed
    },
    isWalletEnabled
      ? {
          link: routes.HAULPAY_BROKER_WALLET,
          title: "My Wallet",
          hidden: !isBrokerSubscribed
        }
      : undefined,
    {
      link: routes.HAULPAY_BROKER_REPORTS,
      title: "Reports",
      hidden: !isBrokerSubscribed
    },
    {
      link: routes.HAULPAY_BROKER_REPORTS,
      title: "Reports",
      hidden: !isCarrierSubscribed
    },
    {
      link: routes.HAULPAY_CREDIT,
      title: "Credit",
      hidden: !isBrokerSubscribed
    },
    {
      link: routes.HAULPAY_CREDIT,
      title: "Credit",
      hidden: !isCarrierSubscribed
    },
    {
      link: routes.HAULPAY_STATUS,
      title: isBroker ? "Factoring or Payments" : "Factoring",
      hidden: !isFactoringRole
    }
  ];
  return items.filter(Boolean) as ISideBarType[];
};

export const LOAD_BOARD_ITEMS = (): ISideBarType[] => {
  const { isShipper, isPostLoadRole, isTruckSearchRole, isSavedPostsRole, isSavedLoadsRole } =
    useUserFeature();
  const { userPermission } = useSelector(selectAccount);

  return [
    {
      link: routes.LOADS_SEARCH,
      title: "Load Search",
      hidden: isShipper
    },
    {
      link: routes.LOADS_POSTED_CREATE,
      title: "Post Load",
      hidden: !userPermission?.can_post_loads
    },
    {
      link: routes.LOADS_POSTED_ALL,
      title: "My Loads",
      hidden: !isPostLoadRole
    },
    {
      link: routes.TRUCKS_SEARCH,
      title: "Truck Search",
      hidden: !isTruckSearchRole
    },
    {
      link: routes.TRUCKS_POST,
      title: "Post Truck",
      hidden: isShipper
    },
    {
      link: routes.TRUCKS_MY_POSTED,
      title: "My Trucks",
      hidden: isShipper
    },
    {
      link: routes.SAVED_POSTS,
      title: "Saved Posts",
      hidden: isSavedPostsRole
    },
    {
      link: routes.SAVED_LOADS,
      title: "Saved Loads",
      hidden: isSavedLoadsRole
    },
    {
      link: routes.SAVED_TRUCKS,
      title: "Saved Trucks",
      hidden: !isShipper
    }
  ];
};

export const USER_SETTINGS_ITEMS = (): ISideBarType[] => {
  const { integrations } = useIntegrations();

  return [
    {
      link: routes.SETTINGS_NOTIFICATIONS,
      title: "Notifications",
      hidden: false
    },
    {
      link: routes.SETTINGS_ACCOUNT,
      title: "Account",
      hidden: false
    },
    {
      link: routes.SETTINGS_PROFILE,
      title: "Profile",
      hidden: false
    },
    {
      link: routes.SETTINGS_BILLING,
      title: "Billing",
      hidden: false
    },
    {
      link: routes.SETTINGS_THEME,
      title: "Theme",
      hidden: false
    },
    {
      link: routes.SETTINGS_HELP,
      title: "Help",
      hidden: false
    },
    {
      link: routes.SETTINGS_INTEGRATIONS,
      title: "Integrations",
      hidden: !integrations.length
    }
  ];
};
